export default "/images/SL_equipements.png?6c28f991c7f7f99f1e45b47f4e62d054";